// ReturnItemsModal.jsx
import React, { useState } from "react";
import { Modal } from "antd";

const RefundedItem = ({ open, onClose, order, onSubmit }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      wrapClassName="return-modal-wrapper"
    >
      <div className="return-modal">
        {/* Top-right close button */}
        <button className="refund-modal-close-top" onClick={onClose}>
          ✕
        </button>

        {/* Header */}
        <div className="return-modal-header">
          <h3>Order Refund Status</h3>
        </div>

        {/* Items */}
        {Array.isArray(order?.refundRequests) &&
        order.refundRequests.length > 0 ? (
          order.refundRequests.map((item, index) => (
            <div className="refund-status-item-card" key={index}>
              <div className="refund-left">
                <div className="refund-qty-box">x{item.quantity}</div>
                <div className="refund-product-name">{item.productName}</div>
              </div>

              <div className={`refund-status-badge ${item.status}`}>
                {item.status}
              </div>
            </div>
          ))
        ) : (
          <p style={{ color: "#fff", textAlign: "center", marginTop: "20px" }}>
            No refund items found
          </p>
        )}
      </div>
    </Modal>
  );
};

export default RefundedItem;
